/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import ClickOutside from 'comps/ClickOutside';
import { SketchPicker } from 'react-color';
import { css, jsx } from '@emotion/core';
import { useState, useEffect } from 'react';

const Box = (props: {
  value: ?string,
  style?: Object,
  testIdPrefix?: string,
}) => (
  <div
    className="ColorBox"
    data-testid={addPrefix(props.testIdPrefix, 'ColorBox')}
    data-color={props.value}
    css={css(
      {
        background: props.value,
        width: 20,
        height: 20,
        borderRadius: 5,
        borderWidth: 1,
        borderColor: '#efefef',
        borderStyle: 'solid',
        display: 'inline-block',
      },
      props.style || {}
    )}
  />
);

const Component = (props: {
  value: any,
  onChange: (string) => any,
  enabled: boolean,
  boxStyle?: Object | string,
  buttonStyle?: Object | string,
  isOpen?: boolean,
  text?: React$Node,
  className?: string,
  testIdPrefix?: string,
}): Element<string> => {
  const [isOpen, setOpen] = useState(Boolean(props.isOpen));
  const [pickerColor, setPickerColor] = useState(props.value);

  useEffect(() => {
    if (!isOpen && props.value !== pickerColor) {
      props.onChange(pickerColor);
    }
  }, [isOpen]);

  const box = isOpen ? (
    <div
      className="ColorBoxContainer"
      css={css(
        'position: relative; display: inline-block; width: 20px; height: 20px;'
      )}
    >
      <Box
        testIdPrefix={props.testIdPrefix}
        value={pickerColor}
        style={props.boxStyle || {}}
      />
      <div
        className="SketchPickerContainer"
        css={css(
          `position: absolute; z-index: 99; top: 0; left: 0; color: initial;
          .sketch-picker > div:nth-of-type(3) > div > div > input {
            padding-right: 0 !important;
          }
          `
        )}
      >
        <ClickOutside
          onClickOutside={() => {
            setOpen(false);
          }}
        >
          <SketchPicker
            color={pickerColor}
            onChange={(value) => {
              setPickerColor(value.hex);
            }}
            onChangeComplete={(value) => {
              setPickerColor(value.hex);
              props.onChange(value.hex);
            }}
          />
        </ClickOutside>
        <a
          data-testid="SecretCloseButton"
          onClick={() => {
            props.onChange(pickerColor);
            setOpen(false);
          }}
        />
      </div>
    </div>
  ) : (
    <Box
      testIdPrefix={props.testIdPrefix}
      value={pickerColor}
      style={props.boxStyle || {}}
    />
  );

  return (
    <button
      className={props.className || ''}
      data-testid={addPrefix(props.testIdPrefix, 'ColorBoxButton')}
      onClick={() => {
        props.enabled && setOpen((v) => !v);
      }}
      css={css({}, props.buttonStyle || {})}
    >
      {box}
      {props.text || ''}
    </button>
  );
};

function addPrefix(testIdPrefix, base) {
  return [testIdPrefix, base].filter(Boolean).join('');
}

export default Component;
